export const START_GETTING_CRM_USERS = 'START_GETTING_CRM_USERS';
export const STOP_GETTING_CRM_USERS = 'STOP_GETTING_CRM_USERS';
export const GET_CRM_USERS = 'GET_CRM_USERS';
export const START_SEARCHING_CRM_USERS = 'START_SEARCHING_CRM_USERS';
export const STOP_SEARCHING_CRM_USERS = 'STOP_SEARCHING_CRM_USERS';
